import assignIn from "lodash/assignIn";

export class FileUploadService {
  constructor(ApiService, $resource, $cookies, Upload) {
    "ngInject";

    this.apiService = ApiService;
    this.$resource = $resource;
    this.$cookies = $cookies;
    this._upload = Upload;

    this.fileUploadResoureceUrl =
      this.apiService.getResourceUrl("/file/upload");
  }
  uploadFile(file, baseDir = "image") {
    let data = assignIn(data, {
      path: baseDir,
      file: file,
    });

    return this._upload.upload({
      url: this.fileUploadResoureceUrl,
      data: data,
    });
  }

  getFileDownloadUrl(id) {
    const token = this.$cookies.get("token");
    return this.apiService.getResourceUrl(
      `v1/files/${id}/preview?JWT=${token}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/libs/file-upload/file-upload.service.js